import React, {useState} from 'react';
import SignInputComponent from 'components/login/SignInputComponent';
import {setNicknameRequest} from 'util/api';
import NiceButton from "../pictures/NiceButton";

const SetNicknameGoogleUser = () => {
    const [nickname, setNickname] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [accepted, setAccepted] = useState(false);

    const handleSetNickname = async () => {
        if (!accepted) return;

        setErrorMessage('');
        try {
            const currentPath = window.location.pathname;
            await setNicknameRequest(nickname, currentPath);
            localStorage.setItem('isLoggedIn', 'true');
            window.location.reload();
        } catch (error) {
            if (error.status !== 400) {
                setErrorMessage('Something went wrong. Please try again later or contact us.');
            } else {
                const errorBodyString = await error.body;
                try {
                    const errorBody = JSON.parse(errorBodyString);
                    if (errorBody.length > 0) {
                        setErrorMessage(errorBody[0].errorText);
                    }
                } catch {
                    setErrorMessage('Something went wrong. Please try again later or contact us.');
                }
            }
        }
    };

    return (
        <div>
            <h2 style={{textAlign: 'center', color: '#10450e'}}>Set Your Nickname</h2>

            <div style={{minHeight: '54px'}}>
                <SignInputComponent
                    inputType="text"
                    name="Nickname"
                    viewText="Nickname"
                    onEnter={handleSetNickname}
                    onValueChange={(value) => setNickname(value)}
                    error={errorMessage}
                    onKeyPressClearError={() => setErrorMessage('')}
                />
            </div>

            <label style={{display: 'block', marginTop: '10px', marginBottom: '8px', fontSize: '12px'}}>
                <input
                    type="checkbox"
                    checked={accepted}
                    onChange={(e) => setAccepted(e.target.checked)}
                />{' '}
                I accept the{' '}
                <a href="/page-rules" target="_blank" rel="noopener noreferrer">
                    Page Conditions
                </a>
            </label>

            <NiceButton onClick={handleSetNickname} disabled={!accepted || !nickname} text={'Set Nickname'}/>
        </div>
    );
};

export default SetNicknameGoogleUser;
